import { Box, Button, Grid, Heading, Text } from "grommet";
import { Home } from "grommet-icons";
import React, { useEffect, useState } from "react";
import { IDetectedBarcode, Scanner as QR } from "@yudiel/react-qr-scanner";
import SkeletonWrapper from "../components/SkeltonWrapper";
import { Exhibitor, GetExhibitors } from "./TreasureHunt";
import { Attendee, useUser } from "../utils/AccountStore";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Scanner = () => {
    const [exhibitors, setExhibitors] = useState([] as Exhibitor[]);
    const navigate = useNavigate();

    const { user } = useUser();

    useEffect(() => {
        GetExhibitors().then((res) => {
            setExhibitors(res.data);
        });
        window.scrollTo(0, 0);
    }, []);

    const handleScan = (barcodes: IDetectedBarcode[]) => {
        let text = barcodes[0]?.rawValue;
        if (text && text.includes("/exhibitors/")) {
            let id = text.split("/exhibitors/")[1];
            if (exhibitors.some((exhibitor) => exhibitor.id === id)) {
                axios.post(`${Server}/api/attendees/scan`, { type: "exhibitor", id, userID: user.id }).then(() => {
                    navigate("/exhibitorDetails/" + id);
                });
            }
        }
    };

    return (
        <div style={{ overflow: "hidden", height: window.innerHeight }}>
            <Box pad="medium" align="center" fill height={{ min: "100vh" }} gap={"small"} background={"brand"}>
                <Grid id="header" columns={["1fr", "auto", "1fr"]} width="100%" align="center">
                    <Home color="white" onClick={() => navigate("/home")} />
                    <Heading level="2" color="white">
                        Scan QR Code
                    </Heading>
                    <Box direction="row" gap="small" align="center" justify="end"></Box>
                </Grid>

                <Box align="center" pad="small" gap="small">
                    <Text color="white" size="large" textAlign="center">
                        Scan the QR code at each zone.
                    </Text>
                    <Box pad="medium" round="medium" background="background-front" align="center" justify="center">
                        <QR onScan={handleScan} constraints={{ facingMode: "environment" }} components={{ finder: false, torch: true }} />
                    </Box>
                </Box>
            </Box>
        </div>
    );
};

export default Scanner;
